import { useEffect, useState } from 'react';

/**
 * Unterhalb des ProERP-eigenen `tablet`-Breakpoints (744 px = iPad mini hoch,
 * `--breakpoint-tablet` in globals.css) — also Telefon. JS-Pendant zu den
 * `tablet:`-Klassen für Fälle, die mehr tun als Klassen umschalten (z. B. eine
 * ganze Seite gar nicht erst aufbauen). `max-width` mit 743.98 px statt der
 * Range-Syntax `(width < 744px)`: die kennt Safari erst ab 16.4.
 */
export const PHONE_MEDIA_QUERY = '(max-width: 743.98px)';

function matches(): boolean {
  return typeof window !== 'undefined' && window.matchMedia(PHONE_MEDIA_QUERY).matches;
}

/**
 * Telefonbreite zur Laufzeit. Der Startwert wird SYNCHRON gelesen — sonst baute
 * eine Seite beim ersten Rendern die Desktop-Variante auf (inkl. Abfragen) und
 * schaltete erst danach um.
 */
export function useIsPhone(): boolean {
  const [isPhone, setIsPhone] = useState(matches);

  useEffect(() => {
    const mql = window.matchMedia(PHONE_MEDIA_QUERY);
    const onChange = () => setIsPhone(mql.matches);
    onChange();
    mql.addEventListener('change', onChange);
    return () => mql.removeEventListener('change', onChange);
  }, []);

  return isPhone;
}
